export default __webpack_public_path__ + "static/media/marker.e866522c.png";